import CommentIcon from '@mui/icons-material/Comment';
import { SpeedDial, SpeedDialAction, SpeedDialIcon } from '@mui/material';
import AssignmentIcon from '@mui/icons-material/Assignment';
import BarChartIcon from '@mui/icons-material/BarChart';
import HubIcon from '@mui/icons-material/Hub';
import InsightsIcon from '@mui/icons-material/Insights';
import MedicalInformationIcon from '@mui/icons-material/MedicalInformation';
import ScatterPlotIcon from '@mui/icons-material/ScatterPlot';
import SpeedIcon from '@mui/icons-material/Speed';
import TheatersIcon from '@mui/icons-material/Theaters';
import { useFeedbackTrigger } from '@odin/huginn-client/ui';
import { useState } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { AsyncBoundary } from '../../aceapi/utils';

const procedureActions = [
    {
        name: 'Detailed View',
        icon: AssignmentIcon,
        path: '/procedures',
    },
    {
        name: 'Compact View',
        icon: InsightsIcon,
        path: '/p',
    },
    {
        name: 'CAQ view',
        icon: BarChartIcon,
        path: '/caq',
    },
    {
        name: 'Performance Annotation',
        icon: SpeedIcon,
        path: '/annotation',
    },
    {
        name: 'Greenlight Guru Patient Report',
        icon: MedicalInformationIcon,
        path: '/patient',
    },
    {
        name: 'Clinical Review',
        icon: ScatterPlotIcon,
        path: '/review',
    },
    {
        name: 'Edit Timeline',
        icon: TheatersIcon,
        path: '/edit',
    },
];

function AsyncProcedureSpeedDial() {
    const { uuid } = useParams();
    const navigate = useNavigate();
    const { pathname } = useLocation();

    const [open, setOpen] = useState(false);
    const { open: openFeedback, available: feedbackAvailable } = useFeedbackTrigger();

    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);

    const handleFeedbackClick = () => {
        openFeedback();
        handleClose();
    };

    const actions = [
        ...(uuid
            ? procedureActions.map((action) => ({
                  ...action,
                  onClick: () => navigate(`${action.path}/${uuid}`),
                  color: pathname.startsWith(`${action.path}/${uuid}`) ? 'info' : 'inherit',
              }))
            : []),
        ...(feedbackAvailable
            ? [
                  {
                      name: 'Feedback',
                      icon: CommentIcon,
                      onClick: handleFeedbackClick,
                      color: 'inherit',
                  },
              ]
            : []),
    ];

    if (actions.length === 0) {
        return null;
    }

    return (
        <SpeedDial
            ariaLabel='App Speed Dial'
            direction='up'
            sx={{ position: 'absolute', bottom: 16, right: 32 }}
            icon={<SpeedDialIcon icon={<HubIcon />} />}
            onClose={handleClose}
            onOpen={handleOpen}
            open={open}
        >
            {actions.map((action) => (
                <SpeedDialAction
                    key={action.name}
                    icon={<action.icon color={action.color} />}
                    tooltipTitle={action.name}
                    onClick={action.onClick}
                />
            ))}
        </SpeedDial>
    );
}

export default function ProcedureSpeedDial(props) {
    return (
        <AsyncBoundary fallback={null}>
            <AsyncProcedureSpeedDial {...props} />
        </AsyncBoundary>
    );
}
